export default class PrintParam4 {
  constructor(label, data) {
    this.label = label
    this.data = data
  }
}

export const EMPTY_PRINT_PARAM4 = new PrintParam4('', '')
export const CARRIER_PRINT_PARAM4 = new PrintParam4('AS CARRIER', 'AS CARRIER')
export const AGENT_FOR_CARRIER_PRINT_PARAM4 = new PrintParam4('AS AGENT FOR THE CARRIER', 'AS AGENT FOR THE CARRIER')
export const AGENT_PRINT_PARAM4 = new PrintParam4('AS AGENT FOR ', 'AS AGENT FOR ')

export const PRINT_PARAM4_TYPES = [
  EMPTY_PRINT_PARAM4,
  CARRIER_PRINT_PARAM4,
  AGENT_FOR_CARRIER_PRINT_PARAM4,
  AGENT_PRINT_PARAM4
]
